import {
  GET_LIST_THONGKETHU,
  GET_LIST_THONGKETHU_SUCCESS,
  GET_LIST_THONGKETHU_FAILURE,
} from "actions/ThongKeThu/actionTypes";

const initialState = {
  getListThongKeThuLoading: false,
  posts: [],
  objList: {
    List: [],
  },
  totalRow: 0,
};

const getListThongKeThu = (state, action) => ({
  ...state,
  getListThongKeThuLoading: true,
});

const getListThongKeThuSuccess = (state, action) => {
  return {
    ...state,
    getListThongKeThuLoading: false,
    objList: action.payload,
  };
};

const getListThongKeThuFailed = (state, action) => ({
  ...state,
  getListThongKeThuLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_THONGKETHU:
      return getListThongKeThu(state, action);
    case GET_LIST_THONGKETHU_SUCCESS:
      return getListThongKeThuSuccess(state, action);
    case GET_LIST_THONGKETHU_FAILURE:
      return getListThongKeThuFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
